export default function getEnvironmentFromUrl() {
  const url = window.location.host;
  const [environment] = url.split('.');

  if (environment === 'portal') return 'PROD';
  if (process?.env?.NODE_ENV !== 'production') return 'LOCAL';

  return environment.toUpperCase();
}
